import { useAppSelector } from 'Store';

import * as selectors from './selectors';

export const useSelectCurrentUserInfo = () => useAppSelector(selectors.selectCurrentUserInfo);

export const useSelectUserDisplayName = () => useAppSelector(selectors.selectUserDisplayName);

export const useSelectUserEmail = () => useAppSelector(selectors.selectUserEmail);

export const useSelectUserAvatar = () => useAppSelector(selectors.selectUserAvatar);

export const useSelectUserAvatarColor = () => useAppSelector(selectors.selectUserAvatarColor);

export const useSelectUserTimezone = () => useAppSelector(selectors.selectUserTimezone);

export const useSelectIsStartBannerHidden = () =>
  useAppSelector(selectors.selectIsStartBannerHidden);

export const useSelectIsMachineBarPinned = () => useAppSelector(selectors.selectIsMachineBarPinned);

export const useSelectAreTipsHidden = () => useAppSelector(selectors.selectAreTipsHidden);

export const useSelectIsSaveCurrentUserInfoSuccess = () =>
  useAppSelector(selectors.selectIsSaveCurrentUserInfoSuccess);

export const useSelectHasUserInfo = () => useAppSelector(selectors.selectHasUserInfo);

export const useSelectUserInitials = () => useAppSelector(selectors.selectUserInitials);

export const useSelectIsStartBannerVisible = () =>
  useAppSelector(selectors.selectIsStartBannerVisible);

export const useSelectIsMachineBarUnpinned = () =>
  useAppSelector(selectors.selectIsMachineBarUnpinned);

export const useSelectIsGetCurrentUserInfoLoading = () =>
  useAppSelector(selectors.selectIsGetCurrentUserInfoLoading);

export const useSelectAreTipsVisible = () => useAppSelector(selectors.selectAreTipsVisible);

export const useSelectUserLanguage = () => useAppSelector(selectors.selectUserLanguage);

export const useSelectIsUserInfoSaveSuccessful = () =>
  useAppSelector(selectors.selectIsUserInfoSaveSuccessful);

export const useSelectShouldShowWelcomeMessage = () =>
  useAppSelector(selectors.selectShouldShowWelcomeMessage);

export const useSelectCanShowTips = () => useAppSelector(selectors.selectCanShowTips);

export const useSelectIsUserSettingsComplete = () =>
  useAppSelector(selectors.selectIsUserSettingsComplete);

export const useSelectUserTheme = () => useAppSelector(selectors.selectUserTheme);

export const useSelectCoursePreferences = () => useAppSelector(selectors.selectCoursePreferences);

export const useSelectCourseViewMode = () => useAppSelector(selectors.selectCourseViewMode);

export const useSelectIsUserDarkTheme = () => useAppSelector(selectors.selectIsUserDarkTheme);

export const useSelectIsUserLightTheme = () => useAppSelector(selectors.selectIsUserLightTheme);
